var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dv-active-ring-chart"},[_c('div',{ref:"active-ring-chart",staticClass:"active-ring-chart-container"}),_c('div',{staticClass:"active-ring-info"},[_c('dv-digital-flop',{attrs:{"config":_vm.digitalFlop}}),_c('div',{staticClass:"active-ring-name",style:(_vm.fontSize)},[_vm._v(_vm._s(_vm.ringName))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }